import { createFileRoute } from "@tanstack/react-router";
import { PosVNextLP } from "@/components/posvnext/PosVNextLP";
import profBruno from "@/assets/orto/prof-bruno.jpg.asset.json";

const TITLE = "Pós em Fisioterapia Esportiva | Versão B | FEO";
const DESC =
  "Versão B da LP: pós-graduação 100% online em Fisioterapia Esportiva. 14 módulos, 360h, reconhecida pelo MEC. Performance, prevenção e retorno seguro ao esporte.";
const URL = "https://fisioemortopedia.com.br/esporte2";

export const Route = createFileRoute("/esporte2")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex" },
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: EsporteLP2,
});

function EsporteLP2() {
  return (
    <PosVNextLP
      product="esporte"
      heroEyebrow="Pós-Graduação · 100% online · MEC"
      heroTitle="Fisioterapia Esportiva que devolve o atleta ao jogo com segurança"
      heroTitleHighlight="devolve o atleta ao jogo"
      heroSubtitle="Avaliação, prevenção, reabilitação e retorno ao esporte, do atleta amador ao profissional, com critério clínico, dose de carga e protocolos baseados em evidência."
      promessas={[
        "Avaliar o atleta com testes funcionais validados",
        "Construir progressão de carga sem recidiva",
        "Decidir return-to-play com critério, não no chute",
        "Atuar com equipe multi e ganhar respeito no clube",
      ]}
      personas={[
        {
          titulo: "Fisio em clube ou academia",
          desc: "Que quer protocolos atualizados e decisões claras de retorno ao esporte.",
        },
        {
          titulo: "Fisio que atende corredor / amador",
          desc: "Que precisa de raciocínio para lesões repetitivas e prevenção real.",
        },
        {
          titulo: "Fisio que quer crescer na área",
          desc: "Que busca certificação MEC e network com referências da fisioterapia esportiva.",
        },
      ]}
      coordenadorNome="Bruno Saragiotto"
      coordenadorFoto={profBruno.url}
      coordenadorQuote="Performance é consequência de raciocínio clínico bem feito, não de protocolo decorado."
      coordenadorBio="Coordenador da pós em Fisioterapia Esportiva da FEO. PhD em fisioterapia musculoesquelética, com produção científica internacional em prevenção e tratamento de lesões esportivas e prática baseada em evidências."
      ementaSubtitle="Grade completa, professores e cronograma da pós em Fisioterapia Esportiva."
      whatsappUrl="https://nimble.li/o9yokpkm"
    />
  );
}
